AgrimarketControllers.controller('subscribeContractOptionController', ['$scope', '$rootScope', '$location', 'enumFactory', 'configurationFactory', 'parametersFactory', 'offerService', 'contractsOptionService', 'parametersService', 'contractsService', '$filter', 'conditionsService', 'signatureService', 'typeOrdersService', 'targetPriceService',
    function ($scope, $rootScope, $location, enumFactory, configurationFactory, parametersFactory, offerService, contractsOptionService, parametersService, contractsService, $filter, conditionsService, signatureService, typeOrdersService, targetPriceService) {

        var init = function () {

            goToStep("Strike");
            $scope.idOfferOption = $rootScope.offerSelected.IdOfferSelected;
            $scope.errorMessage = "";
            $scope.currentContract = {};
            $scope.currentContract.tonnageCurrent = 0;
            $scope.currentContract.isCGChecked = false;
            $scope.showUrlUtilConditionAttachment = false;
            $scope.showUrlSellConditionAttachment = false;
            $scope.selectedConnection = {};
            $scope.signatureYouSign = {};
            $scope.showListChooseContact = true;
            $scope.moduleYousignIsActive = $rootScope.ModuleSignatureElectroniqueYouSign.Active;
            $scope.IsUneal = $rootScope.paramNameCoop === enumFactory.Coops.Uneal ? true : false;
            $scope.listConnection = [];
            $scope.showConfirmButton = true;
            $scope.termsAndConditions = {
                isChecked: false
            };

            $scope.security = {
                Code: ""
            };

            $scope.selectStrikeLabel = $rootScope.editableObjectsFactory.EditableObjects.Select_Strike.Content;

            $scope.idContractOption = 0;

            parametersService.GetParameters(function (dataParam, statusParam) {
                if (statusParam !== undefined && statusParam !== null) {
                    if (statusParam === 400) {
                        $scope.loginErrorMessage = dataParam[0].errors[0].Message;
                    }
                } else {
                    $scope.Parameters = dataParam;

                    if (!$scope.Parameters.FileTermCondition.Value)
                        $scope.showUrlSellConditionAttachment = false;
                    else {
                        $scope.urlSellConditionAttachment = configurationFactory.Url['Api'] + 'Upload/GetAttachment?p=' + $scope.Parameters.FileTermCondition.Value;
                        $scope.showUrlSellConditionAttachment = true;
                    }

                    if (!$scope.Parameters.FileTermeUse.Value)
                        $scope.showUrlUtilConditionAttachment = false;
                    else {
                        $scope.urlUtilConditionAttachment = configurationFactory.Url['Api'] + 'Upload/GetAttachment?p=' + $scope.Parameters.FileTermeUse.Value;
                        $scope.showUrlUtilConditionAttachment = true;
                    }
                }
            });

            LoadDataForSubscription();

        };

        var LoadDataForSubscription = function () {
            $scope.loading = true;
            contractsOptionService.GetDataForSubscribeOption($rootScope.offerSelected.IdExpirySelected, function (data, status) {
                if (status !== null) {
                    if (status === 400)
                        $scope.errorMessage = data[0].errors[0].Message;
                } else {
                    $scope.selectableStrike = data.Strikes;
                    $scope.Offer = data.Offer;
                    $scope.loading = false;
                }
            });
        };

        $scope.GoToContractualisation = function (strike) {
            goToStep("Contractualisation");
            $scope.errorContractualisationMessage = "";
            $scope.selectedStrike = strike;
        };

        $scope.GoToValidation = function () {
            if ($scope.CheckContractualisation())
                goToStep("Validation");
        };

        $scope.ConfirmValidation = function () {

            $scope.showConfirmButton = false;
            $scope.errorSignatureMessage = "";

            // Création de la vm du contrat
            contractOptionVm = {
                IdOffer: $scope.idOfferOption,
                IdExpiry: $rootScope.offerSelected.IdExpirySelected,
                IdStrike: $scope.selectedStrike.IdStrike,
                Quantity: $scope.currentContract.tonnageCurrent,
                Prime: $scope.selectedStrike.Prime,
                Cost: $scope.selectedStrike.Cost,
                Variation: $scope.selectedStrike.Variation,
                StrikeValue: $scope.selectedStrike.Strike,
                DateLimitExercice: $scope.selectedStrike.ExerciceDate,
                IdCrop: $rootScope.offerSelected.IdCropSelected,
                IdTypeOption: $rootScope.offerSelected.IdTypeOptionSelected,
                IdProduct: $rootScope.offerSelected.IdProductSelected
            };

            if (!$scope.termsAndConditions.isChecked) {
                $scope.errorValidationMessage = $rootScope.editableObjectsFactory.EditableObjects.Error_OfferSubscribe_PleaseAcceptGeneralConditionsOfSaleBeforeValidation.Content;
                return;
            }
            // lancement du processus yousign si le module est activé
            if ($scope.moduleYousignIsActive && $scope.IsUneal && $rootScope.CurrentUserRole === "TC") {
                signatureService.GetListConnection($rootScope.selectedClientFromTcForSubscribe.IdUser, function (data, status) {
                    if (status !== null) {
                        if (status === 400) {
                            $scope.errorSignatureMessage = data[0].errors[0].Message;
                            $scope.isConfirmed = false;
                        }
                    }
                    else {
                        $scope.listConnection = data;
                        if ($scope.listConnection.length === 0)
                            $scope.errorSignatureMessage = $rootScope.editableObjectsFactory.EditableObjects.ChooseContacte_OfferSubscribe_ListEmpty_NoBinding_Contacte.Content;
                        $scope.isConfirmed = false;
                        goToStep("SignatureSms");
                    }
                });
            }
            else if ($scope.moduleYousignIsActive && !$scope.IsUneal && $rootScope.CurrentUserRole === "User") {
                contractsOptionService.SaveNewContractOptionAndSendSmsYouSign(contractOptionVm, function (data, status) {
                    if (status !== null) {
                        if (status === 400) {
                            $scope.errorMessage = data[0].errors[0].Message;
                            $scope.isToLate = true;
                            $scope.isConfirmed = false;
                            $scope.counter.pause = true;
                        }
                    } else {
                        $scope.isConfirmed = true;
                        $scope.idContractOption = data.IdContractOption;
                        $scope.hashContractOption = data.HashContractOption;
                        if (data) {
                            if (data.CanAvoidSigning) {
                                $scope.showConfirmButton = true;
                                goToStep("Confirmation");
                            }
                            else {
                                $scope.showConfirmButton = true;
                                $scope.showListChooseContact = false;
                                $scope.signatureYouSign = data;
                                $scope.isConfirmed = false;
                                goToStep("SignatureSms");
                            }
                        } else {
                            $scope.showConfirmButton = true;
                        }
                    }
                });
            }   
            else {
                if ($rootScope.ModuleElectronicSignature.Active && $rootScope.activateSignature) {
                    $scope.SendSecurityCode();
                }
                else {
                    SaveNewContratOption();
                    goToStep("Confirmation");
                }
            }

        };

        $scope.CheckContractualisation = function () {

            if ($scope.currentContract.tonnageCurrent === undefined || $scope.currentContract.tonnageCurrent === null || $scope.currentContract.tonnageCurrent === 0) {
                $scope.errorContractualisationMessage = $rootScope.editableObjectsFactory.EditableObjects.Error_OfferSubscribe_PleaseEnterTonnage.Content;
                return false;
            }

            if ($scope.currentContract.tonnageCurrent <= 0) {
                $scope.errorContractualisationMessage = $rootScope.editableObjectsFactory.EditableObjects.Error_OfferSubscribe_PleaseEnterPositiveNumber.Content;
                return false;
            }

            if ($scope.Offer.CommitmentMin !== null && $scope.currentContract.tonnageCurrent < $scope.Offer.CommitmentMin) {
                $scope.errorContractualisationMessage = $rootScope.editableObjectsFactory.EditableObjects.Error_OfferSubscribe_PleaseEnterTonnageSuperirorOrEqual.Content + $scope.Offer.CommitmentMin + $rootScope.editableObjectsFactory.EditableObjects.Error_OfferSubscribe_Tonne.Content;
                return false;
            }

            if ($scope.Offer.CommitmentMax !== null && $scope.currentContract.tonnageCurrent > $scope.Offer.CommitmentMax) {
                $scope.errorContractualisationMessage = $rootScope.editableObjectsFactory.EditableObjects.Error_OfferSubscribe_PleaseEnterTonnageInferiorOrEqual.Content + $scope.Offer.CommitmentMax + $rootScope.editableObjectsFactory.EditableObjects.Error_OfferSubscribe_Tonne.Content;
                return false;
            }

            if ($scope.Offer.QuantityLeft !== null && $scope.currentContract.tonnageCurrent > $scope.Offer.QuantityLeft) {
                $scope.errorContractualisationMessage = $rootScope.editableObjectsFactory.EditableObjects.Error_OfferSubscribe_TonnageIsLimitedOnThisOffer.Content + $scope.Offer.QuantityLeft + $rootScope.editableObjectsFactory.EditableObjects.Error_OfferSubscribe_Tonne.Content;
                return false;
            }

            if ($scope.Offer.Quotity !== null && $scope.currentContract.tonnageCurrent % $scope.Offer.Quotity !== 0) {
                $scope.errorContractualisationMessage = $rootScope.editableObjectsFactory.EditableObjects.Error_OfferSubscribe_PleaseEnterTonnageRespectingQuotity.Content + $scope.Offer.Quotity + ".";
                return false;
            }

            return true;
        };

        $scope.ValidateConnection = function () {
            // Création de la vm du contrat
            contractOptionVm = {
                IdOffer: $scope.idOfferOption,
                IdExpiry: $rootScope.offerSelected.IdExpirySelected,
                IdStrike: $scope.selectedStrike.IdStrike,
                Quantity: $scope.currentContract.tonnageCurrent,
                Prime: $scope.selectedStrike.Prime,
                Cost: $scope.selectedStrike.Cost,
                Variation: $scope.selectedStrike.Variation,
                StrikeValue: $scope.selectedStrike.Strike,
                DateLimitExercice: $scope.selectedStrike.ExerciceDate,
                IdCrop: $rootScope.offerSelected.IdCropSelected,
                IdTypeOption: $rootScope.offerSelected.IdTypeOptionSelected,
                IdProduct: $rootScope.offerSelected.IdProductSelected
            };

            if ($scope.selectedConnection) {
                if ($scope.selectedConnection.IdConnection) {
                    $scope.showConfirmButton = false;
                    $scope.errorSignatureMessage = "";
                    contractOptionVm.IdConnection = $scope.selectedConnection.IdConnection;
                    contractsOptionService.SaveNewContractOptionAndSendSmsYouSign(contractOptionVm, function (data, status) {
                        if (status !== null) {
                            if (status === 400) {
                                $scope.errorMessage = data[0].errors[0].Message;
                                $scope.isToLate = true;
                                $scope.isConfirmed = false;
                                $scope.counter.pause = true;
                            }
                        } else {
                            $scope.isConfirmed = true;
                            $scope.idContractOption = data.IdContractOption;
                            $scope.hashContractOption = data.HashContractOption;
                            if (data) {
                                if (data.CanAvoidSigning) {
                                    $scope.showConfirmButton = true;                                   
                                    goToStep("Confirmation");
                                }
                                else {
                                    $scope.showConfirmButton = true;
                                    $scope.showListChooseContact = false;
                                    $scope.signatureYouSign = data;
                                    $scope.isConfirmed = false;
                                    goToStep("SignatureSms");
                                }
                            } else {
                                $scope.showConfirmButton = true;
                            }
                        }
                    });
                }
                else
                    $scope.errorSignatureMessage = $rootScope.editableObjectsFactory.EditableObjects.ChooseContacte_OfferSubscribe_ListEmpty.Content;
            } else {
                $scope.errorSignatureMessage = $rootScope.editableObjectsFactory.EditableObjects.ChooseContacte_OfferSubscribe_ListEmpty.Content;
            }
        };

        $scope.CheckSmsForYouSign = function () {
            $scope.isConfirmed = true;
            $scope.showConfirmButton = false;
            signatureService.SignatureWithCodeYouSign($scope.signatureYouSign.Signature.FilesIds[0], $scope.newAuthenticationId ? $scope.newAuthenticationId : $scope.signatureYouSign.Signature.AuthenticationId, $scope.security.Code, function (data, status) {
                if (status !== null) {
                    if (status === 400) {
                        $scope.errorMessage = data[0].errors[0].Message;
                        $scope.isConfirmed = false;
                    }
                }
                else {
                    if (data && (data === "true" || data === "1")) {
                        $scope.errorSignatureMessage = "";
                        goToStep("Confirmation");
                    }
                    else {
                        $scope.successMessage = "";
                        $scope.showConfirmButton = true;
                        $scope.isConfirmed = false;
                        if (!$scope.security.Code)
                            $scope.errorSignatureMessage = $rootScope.editableObjectsFactory.EditableObjects.Error_OfferSubscribe_PleaseEnterCodeReceivedBySms.Content;
                        else
                            $scope.errorSignatureMessage = $rootScope.editableObjectsFactory.EditableObjects.Error_OfferSubscribe_CodeEnteredNotCorrespondToCodeSended.Content;
                    }
                }
            });
        };

        $scope.SendSecurityCodeYouSign = function () {
            signatureService.ResendCodeYouSign($scope.signatureYouSign.Signature.MemberId, function (data, status) {
                if (status !== null) {
                    if (status === 400) {
                        $scope.errorMessage = data[0].errors[0].Message;
                        $scope.isConfirmed = false;
                    }
                }
                else {
                    if (data) {
                        $scope.newAuthenticationId = data.AuthenticationId;
                        $scope.errorSignatureMessage = "";
                        $scope.successMessage = $rootScope.editableObjectsFactory.EditableObjects.Success_OfferSubscribe_CodeResend.Content;
                    }
                }
            });
        };

        $scope.SendSecurityCode = function () {
            signatureService.SendSmsElectronicSignatureForOption(function (data, status) {
                if (status !== null) {
                    if (status === 400) {
                        $scope.errorMessage = data[0].errors[0].Message;
                    }
                }
                else {
                    $scope.security.Code = "";
                    goToStep("SignatureSms");
                }
            });
        };

        $scope.ChecksmsCode = function () {
            if ($rootScope.ModuleElectronicSignature.Active && $rootScope.activateSignature) {
                var idContractOption = "";
                if ($scope.idContractOption)
                    idContractOption = $scope.idContractOption;
                signatureService.CheckSecurityCodeOption($scope.security.Code, idContractOption, function (data, status) {
                    if (status !== null) {
                        if (status === 400)
                            $scope.errorSignatureMessage = data[0].errors[0].Message;
                    }
                    else {
                        SaveNewContratOption(true);
                    }
                });
            }
        };

        var SaveNewContratOption = function (isSignedWithoutThirdParty) {

            contractOptionVm = {
                IdOffer: $scope.idOfferOption,
                IdExpiry: $rootScope.offerSelected.IdExpirySelected,
                IdStrike: $scope.selectedStrike.IdStrike,
                Quantity: $scope.currentContract.tonnageCurrent,
                Prime: $scope.selectedStrike.Prime,
                Cost: $scope.selectedStrike.Cost,
                Variation: $scope.selectedStrike.Variation,
                StrikeValue: $scope.selectedStrike.Strike,
                DateLimitExercice: $scope.selectedStrike.ExerciceDate,
                IdCrop: $rootScope.offerSelected.IdCropSelected,
                IdTypeOption: $rootScope.offerSelected.IdTypeOptionSelected,
                IdProduct: $rootScope.offerSelected.IdProductSelected,
                IsSignedWithoutThirdParty: isSignedWithoutThirdParty,
            };
            contractsOptionService.SaveNewContractOption(contractOptionVm, function (data, status) {
                $scope.errorSignatureMessage = "";
                if (status !== null) {
                    if (status === 400) {
                        $scope.errorMessage = data[0].errors[0].Message;
                    }
                } else {
                    $scope.idContractOption = data.idContractOption;
                    $scope.hashContractOption = data.hashContractOption;
                    goToStep("Confirmation");
                }
            });
        };

        $scope.Cancel = function () {
            if ($rootScope.paramDisplayContracts == "1") {
                $location.path("user/contracts_V2/view/current");
            }
            else {
                $location.path("user/offers/view/" + enumFactory.TypeOffer.Option);
            }
        };

        $scope.ChangeConnection = function () {
            $scope.selectedConnection = $filter('filter')($scope.listConnection, { IdConnection: $scope.listConnection.IdConnection }, true)[0];
        };

        $rootScope.onRefresh = function () {
            init();
        };

        init();

        function goToStep(step) {
            $scope.step = step;
            moveVehicle();
        }
    }]);
